import React from "react";
import "./cardcompra.css";
import {
  ModernTv,
  Wifi,
  Cart,
  Phone,
  DataTransferBoth,
} from "iconoir-react";
import { calling } from "../FuntionCall/calling";

function CardcompraInit(props) {
  const precio = props.precio_persona;
  const estrat = props.estratoview === "1-3" ? 1 : 5;
  const estratoviews = props.estratoview === "1-3" ? "1,2,3" : "4,5,6";
  const descuento = props.descuento_valor[estrat];
  /**
   * The function `megasadicionales` returns a JSX element containing a heading with a dynamic number
   * of additional megabytes.
   * @param e - The parameter `e` represents a number that is being passed to the `megasadicionales`
   * function.
   * @returns The code is returning JSX elements wrapped in an h2 tag. The returned JSX elements
   * include a b tag with the value of e + parseInt(props.velocidad) followed by the text "Megas" and a
   * DataTransferBoth component. There is also an h6 tag with the value of Math.trunc(props.velocidad)
   * followed by the text "Megas".
   */
  const megasadicionales = (e) => {

    if ((e) => 0) {
      return (
        <div style={{ fontSize: "30px" }}>
          {/* <h6 style={{ marginBottom: "0.6rem" }}>
            <b>Recibes</b>
          </h6> */}

          <b className="text-colorprimary inline-flex justify-center"
          >
            {" "}
            {e + parseInt(props.velocidad)} Megas
            <DataTransferBoth style={{ width: "10%" }} />
          </b>
          
          <div style={{ marginBottom: "-0.9rem" }}></div>
          {props.discount_months && props.discount_months !== props.months ? (
            <div style={{ marginBottom: "-1.5rem", marginTop: "-1.5rem" }}>
              <b style={{ fontSize: "12px", color: "#4a1272" }}>x{props.discount_months} meses</b>
            </div>
          ) : (
            <div style={{ marginBottom: "-1.5rem", marginTop: "-1.5rem", opacity: 0 }} aria-hidden="true">
              <b style={{ fontSize: "12px" }}>&nbsp;</b>
            </div>
          )}
          <div style={{ display: "inline-flex", marginTop: "-882rem" }}>
            <h6 className="presnorm"> {Math.trunc(props.velocidad)} Megas</h6>
          </div>

          {/* <h3 style={{ fontSize: "15px" }}>Megas Simétricas</h3> */}
        </div>
      );
      // <div>
      //   <h2 style={{fontSize: "70px"}}><b>{props.velocidad}</b></h2><h3 style={{fontSize: "25px"}}>Megas Simétricas</h3>
      //  </div>
    }
  };

  /**
   * The function `fun` calls a function `props.funcion` and passes `props` as an argument.
   */
  const fun = () => {
    props.funcion(props);
  };

  /**
   * The function `icons_change` takes a parameter `tipoplan` and returns a JSX element based on the
   * value of `tipoplan`.
   * @param tipoplan - The parameter "tipoplan" is a string that represents the type of plan. It can
   * have the following values: "Triple", "Dupla", "Doble", or "Internet".
   * @returns The function `icons_change` returns JSX elements based on the value of the `tipoplan`
   * parameter.
   */
  const icons_change = (tipoplan) => {
    if (tipoplan === "Triple") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div className="telefonia" style={{ display: "none" }}>
                <div>
                  <span className="minutos-incluidos">ilimitados</span>
                  minutos a destinos fijos locales
                </div>
              </div>
              <Phone
                className="icono-telefonia"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Telefonia"
              />
            </div>
            <div>
              <b>Fija local ilimitada</b>
            </div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div className="internet" tecnologia="108" style={{ display: "none" }}>
                <div>
                  Internet de
                  <span className="velocidad-bajada">{props.velocidad}</span>
                  Mbps de bajada
                </div>
                <div>
                  Internet de
                  <span className="velocidad-subida">{props.velocidad}</span>
                  Mbps de subida
                </div>
              </div>
              <Wifi
                className="Internet"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Internet"
                tecnologia="108"
              />
            </div>
            <div className="velocidad-bajada" style={{ display: "none" }}>
              {props.velocidad} Megas
            </div>

            <div className="velocidad-subida">{props.velocidad} Megas</div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div
                className="television"
                tecnologia="3"
                style={{ display: "none" }}
              >
                <span className="canales-hd">48</span> canales HD
              </div>
              <ModernTv
                className="icono-television"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Television"
                tecnologia="3"
              />
            </div>
            <div className="canales-hd" style={{ display: "none" }}>
              48 Canales
            </div>
            <div className="canales-sd" style={{ display: "none" }}>
              65 Canales
            </div>
            <div>
              <b>113 canales</b>
            </div>
          </div>
        </>
      );
    } else if (tipoplan === "Dupla") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>

          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div className="telefonia" style={{ display: "none" }}>
                <div>
                  <span className="minutos-incluidos">ilimitados</span>
                  minutos a destinos fijos locales
                </div>
              </div>
              <Phone
                className="icono-telefonia"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Telefonia"
              />
            </div>
            <div>
              <b>Fija local ilimitada</b>
            </div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div className="internet" tecnologia="108" style={{ display: "none" }}>
                <div>
                  Internet de
                  <span className="velocidad-bajada">{props.velocidad}</span>
                  Mbps de bajada
                </div>
                <div>
                  Internet de
                  <span className="velocidad-subida">{props.velocidad}</span>
                  Mbps de subida
                </div>
              </div>
              <Wifi
                className="Internet"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Internet"
                tecnologia="108"
              />
            </div>
            <div className="velocidad-bajada" style={{ display: "none" }}>
              {props.velocidad} Megas
            </div>

            <div className="velocidad-subida">{props.velocidad} Megas</div>
          </div>
        </>
      );
    } else if (tipoplan === "Doble") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div className="telefonia" style={{ display: "none" }}>
                <div>
                  <span className="minutos-incluidos">ilimitados</span>
                  minutos a destinos fijos locales
                </div>
              </div>
              <Phone
                className="icono-telefonia"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Telefonia"
              />
            </div>
            <div>
              <b>Fija local ilimitada</b>
            </div>
          </div>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div
                className="television"
                tecnologia="3"
                style={{ display: "none" }}
              >
                <span className="canales-hd">48</span> canales HD
              </div>
              <ModernTv
                className="icono-television"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Television"
                tecnologia="3"
              />
            </div>
            <div className="canales-hd" style={{ display: "none" }}>
              48 Canales
            </div>
            <div className="canales-sd" style={{ display: "none" }}>
              65 Canales
            </div>
            <div>
              <b>113 canales</b>
            </div>
          </div>
        </>
      );
    } else if (tipoplan === "Internet") {
      return (
        <>
          <b
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1.5rem",
            }}
          >
            Incluye
          </b>
          <div
            className="rd"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
              height: "3rem",
            }}
          >
            <div className="rt">
              <div className="internet" tecnologia="108" style={{ display: "none" }}>
                <div>
                  Internet de
                  <span className="velocidad-bajada">{props.velocidad}</span>
                  Mbps de bajada
                </div>
                <div>
                  Internet de
                  <span className="velocidad-subida">{props.velocidad}</span>
                  Mbps de subida
                </div>
              </div>
              <Wifi
                className="icono-internet"
                style={{ width: "70%", height: "60%", marginBottom: "4px" }}
                alt="Internet"
                tecnologia="108"
              />
            </div>
            <div className="velocidad-bajada" style={{ display: "none" }}>
              {props.velocidad} Megas
            </div>

            <div className="velocidad-subida">{props.velocidad} Megas</div>
          </div>
        </>
      );
    }
  };

  return (
    <div className="card-entry-hover flex justify-center items-center flex-col mt-2 mb-2 shadow-md bg-white border-transparent rounded-xl" >

      <div>
        <div
          className="plan pospago"
          dane="76001,76520,76892,76130,76364"
          valor-numerico={parseInt(precio[estrat] || precio.valor)}
          estrato={estratoviews}
          titulo={props.nombreplan}
        >
          <div className="operador" operador-nit="890399003" style={{ display: "none" }}>EMCALI</div>
          <img className="operador-logo" src="https://c748596267.imgdist.com/pub/bfra/zs95jvh4/uy4/tyz/u0a/logo_emcali.png" alt="EMCALI" style={{ display: "none" }} />
          <div className="url-comercial" style={{ display: "none" }}>
            https://portalservicios.emcali.net.co/planes
          </div>
          <h6 className="mt-3">Plan residencial</h6>
          <div className="p-4 pt-1" key={props.id}>
            <div>
              {megasadicionales(parseInt(props.megas))}
            </div>
            <div className="">
              <div className="text-2xl">
                <h6>Estrato {props.estratoview}</h6>
                <b>
                  {new Intl.NumberFormat("es-CO", {
                    style: "currency",
                    currency: "COP",
                    minimumFractionDigits: 0,
                  }).format(Math.trunc(descuento[estrat] || descuento))}
                </b>{" "}
                <b style={{ fontSize: "12px" }}>x{props.months} meses</b>
                <div
                  className="valor card-title pricing-card-title"
                  valor-numerico={parseInt(precio[estrat] || precio.valor)}
                  estrato="1,2,3,4,5,6"
                >
                  <h5 className="opacity-50 line-through text-sm	">
                    {new Intl.NumberFormat("es-CO", {
                      style: "currency",
                      currency: "COP",
                      minimumFractionDigits: 0,
                    }).format(Math.trunc(precio[estrat] || precio.valor))}
                  </h5>
                </div>
              </div>
            </div>
            <div className="rounded-xl text-sm text-red-500 border-red-500 border-2 mx-4">
              <h3 className="text-sm m-1">
                <b>{props.descuento}% dto online</b>
              </h3>
            </div>
            <div className="row">{icons_change(props.tipoplan)}</div>
            <div className="flex justify-center items-center">
              <button className="action-button buy-button" onClick={() => fun()}>
                <Cart className="icon" style={{}} />
                <b>{props.nombreButton}</b>
              </button>
            </div>
            <div className="flex justify-center items-center mt-2" style={{ display: props.display }}>
              <button
                className="action-button phone-button"
                onClick={() => {
                  calling(props.nombreplan);
                }}
              >
                <Phone className="icon" style={{}} />
                <b>Te asesoramos</b>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardcompraInit;
